export default __webpack_public_path__ + "static/media/circle1.5dcacc92.png";